import { render } from "./RiLnbBookmarks.vue?vue&type=template&id=35243aec"
import script from "./RiLnbBookmarks.vue?vue&type=script&lang=js"
export * from "./RiLnbBookmarks.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiLnbBookmarks.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "35243aec"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('35243aec', __exports__)) {
    api.reload('35243aec', __exports__)
  }
  
  module.hot.accept("./RiLnbBookmarks.vue?vue&type=template&id=35243aec", () => {
    api.rerender('35243aec', render)
  })

}


export default __exports__